
const normalizeStatusId = (statusId) => {
    const normalized = Number(statusId);
    return Number.isNaN(normalized) ? statusId : normalized;
}

const operatorCanEdit = (statusId) => {
    const statuses = [3];
    //const statuses = [ 2, 3, 6, 9, 12 ];
    return statuses.includes(normalizeStatusId(statusId));
}

const operatorCanRead = (statusId) => {
    return true;
}

const operatorCanRunProcess = (statusId) => {
    const statuses = [ 3, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18 ];
    return statuses.includes(normalizeStatusId(statusId));
}

const shippingCanRunProcess = (statusId) => {
    const statuses = [ 15, 16, 17, 18 ];
    return statuses.includes(normalizeStatusId(statusId));
}

const clientCanEdit = (statusId) => {
    const statuses = [ 1, 4 ];
    return statuses.includes(normalizeStatusId(statusId));
}

const clientCanRead = (statusId) => {
    return true;
}

const clientCanRunProcess = (statusId) => {
    const statuses = [ 4, 8 ];
    return statuses.includes(normalizeStatusId(statusId));
}


const ReadOnly = ({statusId, operator = false}) => {

    if (!clientCanEdit(statusId) && !operator)
        return (
            <div className="card p-4">
                Występujesz w roli klienta usługi.<br/>
                Twój wniosek jest obecnie obsługiwany przez operatora.
                {
                    clientCanRunProcess(statusId) && (
                        <span>Możesz wykonać czynności na wniosku.</span>
                    )
                }
            </div>
        )

    if (operator && !operatorCanEdit(statusId))
        return (
            <div className="card p-4">
                Występujesz w roli operatora.<br/>
                Wniosek jest obecnie obsługiwany przez klienta.
                {
                    operatorCanRunProcess(statusId) && (
                        <span>Możesz wykonać czynności na wniosku.</span>
                    )
                }
            </div>
        )
}

export default ReadOnly;

export { 
    operatorCanEdit,
    operatorCanRead,
    operatorCanRunProcess,
    shippingCanRunProcess,
    clientCanEdit,
    clientCanRead,
    clientCanRunProcess
 };
